import { Container, Paper } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Header } from '../header';

export function AuthLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div>
      <Header />
      <Container sx={{ mt: 3.5 }} maxWidth={false}>
        <Paper>{children}</Paper>
      </Container>
    </div>
  );
}
